import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';

const SetPasswordPage = () => {
  const [searchParams]                        = useSearchParams();
  const token                                 = searchParams.get('token');
  const [password, setPassword]               = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError]                     = useState('');
  const [loading, setLoading]                 = useState(false);
  const [done, setDone]                       = useState(false);
  const navigate                              = useNavigate();

  if (!token) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <p style={styles.errorMsg}>Invalid setup link. Please request a new one.</p>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <p style={styles.successMsg}>Password set successfully. Please log in.</p>
          <button style={styles.btn} onClick={() => navigate('/login')}>Go to Login</button>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      return setError('Passwords do not match.');
    }
    setLoading(true);
    try {
      await api.post('/auth/set-password', { token, password });
      setDone(true);
    } catch (err) {
      const status = err.response?.status;
      if (status === 429) {
        setError('Too many attempts. Please wait a few minutes and try again.');
      } else {
        setError(err.response?.data?.message || 'Invalid or expired link. Please request a new one.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Set Your Password</h2>
        <p style={styles.subtitle}>Create a password for your LifeChiAI account.</p>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={styles.field}>
            <label style={styles.label}>Password</label>
            <input
              type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input} placeholder="At least 8 characters"
              required minLength={8}
            />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Confirm Password</label>
            <input
              type="password" value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              style={styles.input} placeholder="Repeat your password"
              required minLength={8}
            />
          </div>
          <button
            type="submit"
            style={loading ? { ...styles.btn, opacity: 0.7 } : styles.btn}
            disabled={loading}
          >
            {loading ? 'Setting Password...' : 'Set Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #071e12 0%, #0a1f14 30%, #0c2617 60%, #071e12 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '20px', fontFamily: "'Open Sans', sans-serif"
  },
  card: {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '16px', padding: '48px 40px', width: '100%', maxWidth: '420px',
    backdropFilter: 'blur(20px)', boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
  },
  title: {
    fontFamily: "'Raleway', sans-serif", fontSize: '22px', fontWeight: '800',
    color: '#fff', margin: '0 0 8px', letterSpacing: '0.5px'
  },
  subtitle: { fontSize: '13px', color: 'rgba(255,255,255,0.4)', margin: '0 0 28px' },
  error: {
    background: 'rgba(192,57,43,0.2)', border: '1px solid rgba(192,57,43,0.4)',
    borderRadius: '6px', padding: '12px 16px', color: '#e74c3c',
    fontSize: '13px', marginBottom: '20px'
  },
  successMsg: {
    color: '#8DC63F', fontFamily: "'Raleway', sans-serif", fontSize: '16px',
    fontWeight: '700', textAlign: 'center', marginBottom: '24px'
  },
  errorMsg: { color: '#e74c3c', fontSize: '14px', textAlign: 'center' },
  field: { marginBottom: '18px' },
  label: {
    display: 'block', fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px',
    textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)',
    marginBottom: '7px', fontFamily: "'Raleway', sans-serif"
  },
  input: {
    width: '100%', padding: '12px 14px', background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)', borderRadius: '5px',
    color: '#fff', fontSize: '14px', outline: 'none',
    boxSizing: 'border-box', fontFamily: "'Open Sans', sans-serif"
  },
  btn: {
    width: '100%', padding: '13px', background: '#4a8f82', color: '#fff',
    border: 'none', borderRadius: '5px', fontFamily: "'Raleway', sans-serif",
    fontSize: '12px', fontWeight: '700', letterSpacing: '1.5px',
    textTransform: 'uppercase', cursor: 'pointer', marginTop: '8px'
  }
};

export default SetPasswordPage;
